<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="materialPrice"
        @select="selectHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle"
    >
      <template slot="otherBtn">
        <el-upload
            v-if="limits.importAuth"
            action=""
            :http-request="importFile"
            :show-file-list="false"
            style="float: left; margin-right: 4px;">
          <el-button type="primary" :loading="importLoading">导入</el-button>
        </el-upload>
        <el-button
            v-if="limits.importAuth"
            type="primary"
            plain
            icon="el-icon-download"
            @click="downloadModel">
          批量导入模板下载
        </el-button>
        <!--        <el-button type="primary" @click="submit">提交</el-button>-->
        <!--        <el-button type="primary" @click="pass">通过</el-button>-->
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="物料编号">
            <el-input v-model="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable placeholder="请选择状态">
              <el-option label="全部" value="-2"/>
              <el-option label="未审核" value="0"/>
              <el-option label="未维护" value="-1"/>
              <el-option label="已提交" value="10"/>
              <el-option label="未通过" value="20"/>
              <el-option label="已通过" value="30"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <material-price-edit ref="materialPriceEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import MaterialPriceEdit from "@/views/information/MaterialPrice/MaterialPriceEdit";
  import loginUtil from "@/util/loginUtil";
  export default {
    // name:"MaterialPriceList",
    components: { viewTable, MaterialPriceEdit},
    data() {
      return {
        limits: {
          editAuth: this.$auth(604),
          importAuth: this.$auth(642),
        },
        priceAEditAuth: this.$auth(40),
        priceBEditAuth: this.$auth(41),
        priceCEditAuth: this.$auth(42),
        priceDEditAuth: this.$auth(43),
        priceCBEditAuth: this.$auth(44),
        filter: {
          no: "",
          materialNo: "",
          name: "",
          materialName: "",
          status: "",
          materialTypeId: "",
          mrpType: "",
          feedingType: "",
          specification: "",
          vehicleName: "",
        },
        importLoading:false,
        selection: [],
        materialType: [],
        columnsProperty: [
          {
            key: "no",
            width: 120,
            align: "center",
            // render: (h, params) => {
            //   return h(
            //     "span",
            //     {
            //       style: {
            //         color: "#2d8cf0",
            //         cursor: "pointer",
            //       },
            //       on: {
            //         click: () => {
            //           this.$refs.materialPriceEdit.open(params.row, true);
            //         },
            //       },
            //     },
            //     params.row.no
            //   );
            // },
          },
          {
            key: "standardPrice",
            minWidth: 200,
            render: (h, params) => {
              return h(
                "span",
                this.priceAEditAuth?params.row.standardPrice:"***",
              );
            },
          },
          {
            key: "level1Price",
            minWidth: 200,
            render: (h, params) => {
              return h(
                "span",
                this.priceBEditAuth?params.row.level1Price:"***",
              );
            },
          },
          {
            key: "level2Price",
            minWidth: 200,
            render: (h, params) => {
              return h(
                "span",
                this.priceCEditAuth?params.row.level2Price:"***",
              );
            },
          },
          {
            key: "level3Price",
            minWidth: 200,
            render: (h, params) => {
              return h(
                "span",
                this.priceDEditAuth?params.row.level3Price:"***",
              );
            },
          },
          {
            key: "costPrice",
            minWidth: 200,
            render: (h, params) => {
              return h(
                "span",
                this.priceCBEditAuth?params.row.costPrice:"***",
              );
            },
          },
          {
            key: "name",
            minWidth: 200,
          },
          {
            key: "zmyxh",
            minWidth: 200,
          },
          {
            key: "unit",
            width: 100,
          },
          {
            key: "mappingMaterialNo",
            width: 200,
            align: "center",
          },
          {
            key: "materialGroupNO",
            width: 100,
            align: "center",
          },
          {
            key: "mrpController",
            minWidth: 200,
          },
          {
            key: "softInfo",
            width: 100,
            align: "center",
          },
          {
            key: "manufacturerModel",
            width: 200,
            align: "center",
          },
          {
            key: "productDistribution",
            width: 100,
            align: "center",
          },
          {
            key: "productLayer",
            width: 100,
            align: "center",
          },
          {
            key: "procurementType",
            width: 100,
            align: "center",
          },
          // {
          //   key: "action",
          //   align: "center",
          //   width: 140,
          //   slot: "action",
          //   fixed: "right",
          // },
        ],
      };
    },
    mounted() {
      this.getAllTypeList();
    },

    methods: {

      selectHandle(selection) {
        this.selection = selection;
      },

      addEditHandle(row) {
        console.log(row);
        this.$refs.materialPriceEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "materials", row.materialID).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      //下载导入模板
      downloadModel() {
        window.open("/file/价格导入模板.xlsx");
      },

      //导入
      importFile(params) {
        this.importLoading = true;
        let formData = new FormData();
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http.post("basic", "materialPrice/importPrice", formData).then((res) => {
          if (res.success) {
            this.importLoading = false;
            this.loadData(1);
            this.$message.success(res.data);
          } else {
            this.importLoading = false;
            this.$message.error(res.data);
          }
        }).catch(() => {
          this.importLoading = false;
          this.$message.error("导入失败");
        });
      },

      submit() {
        this.$http.post("basic","materialPrice/submit",this.selection)
          .then(resp=>{
            if (resp.success) {
              this.$message.success("提交成功");
              this.loadData();
            }
          });
      },

      pass() {
        this.$http.post("basic","materialPrice/pass",this.selection)
          .then(resp=>{
            if (resp.success) {
              this.$message.success("提交成功");
              this.loadData();
            }
          });
      },
    },
  };
</script>
